import { BannersConfig } from '../../../models';

export const DEFAULT_BANNERS_CONFIG: BannersConfig = {
  position: 'every-nth-row',
  rowFrequency: 3
};
